// todo: determine later how we want to parse it
// e.g. /en-gb/settings/reset-password -> settings/reset-password
export function pathToSearchParam(path: string): string {
    // Remove language
    path = path.replace(/\/[a-z]{2}-[a-z]{2}/, '');
    // Normalize the URL by removing / at start and end of string
    path = path.replace(/^\/|\/$/g, '');
    return path;
}
